module.exports = __webpack_public_path__ + "static/media/logo-스푼라디오@2x.6a70353c.png";